import React, { useState, useEffect } from 'react';
import SEO from '../components/SEO';
import { organizationSchema, faqSchema } from '../utils/schemas';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import TrustIndicators from '../components/TrustIndicators';
import Services from '../components/Services';
import Testimonials from '../components/Testimonials';
import FAQ, { DEFAULT_FAQS } from '../components/FAQ';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import FloatingCTA from '../components/FloatingCTA';

const Home = () => {
  const [showFloatingCTA, setShowFloatingCTA] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setShowFloatingCTA(true);
      } else {
        setShowFloatingCTA(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Award-Winning Mortgage Brokers"
        description="Award-winning mortgage brokers helping Australians with home loans, refinancing, investment property, and more. Offices in Darwin, Melbourne, Brisbane and Sydney."
        path="/"
        schema={[organizationSchema(), faqSchema(DEFAULT_FAQS)]}
      />
      <Navigation />
      <Hero />
      <TrustIndicators />
      <Services />
      <Testimonials />
      <FAQ />
      <ContactForm />
      <Footer />
      {showFloatingCTA && <FloatingCTA />}
    </div>
  );
};

export default Home;